import { Link } from "react-router-dom";

export default function Banner() {
  return (
    <div className="relative bg-white overflow-hidden">
      <div className=" sm:pt-24 lg:pt-10 pb-6 ">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 sm:static">
          <div className="sm:max-w-lg text-center sm:text-left">
            <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-6xl hidden lg:block">
              HISTORI AI
            </h1>
            <p className="text-xl text-gray-900">
            Buy and Sell Antiques, Relics, and Historical Artifacts Easily.
            </p>
            <p className="text-xl text-gray-900">
            AI-Powered Assistance.
            </p>
          </div>

          {/* Ocultar en móvil, mostrar en escritorio */}
          <div className="mt-10 hidden lg:block">
            {/* Grid de imágenes */}
            <div
              aria-hidden="true"
              className="pointer-events-none lg:absolute lg:inset-y-0 lg:max-w-7xl lg:mx-auto lg:w-full"
            >
              
            </div>
            {/* Fin de imágenes */}
          </div>
        </div>
      </div>
    </div>
  );
}
